"use strict";
'use es6';

var _AppBootstrapper = require("./AppBootstrapper");

(0, _AppBootstrapper.startApp)();